module.exports = __webpack_public_path__ + "images/cffcac0f4b25f9d2bb4a2e031a9e36ac.png";